import React from 'react';

const EditIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15.21" height="15.21" viewBox="0 0 15.21 15.21">
      <path fill="#3E88EF" d="M4.5,15.779v2.969H7.469l8.755-8.755L13.255,7.023ZM18.519,7.7a.788.788,0,0,0,0-1.116L16.667,4.728a.788.788,0,0,0-1.116,0L14.1,6.176l2.969,2.969Z"
        transform="matrix(0.998, -0.07, 0.07, 0.998, -4.803, -3.177)" />
    </svg>
  );
};

export default EditIcon;

export const PlusIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15.21" height="15.21" viewBox="0 0 24 24" >
  <path  fill="#3E88EF" d="M13 11V3C13 2.448 12.552 2 12 2C11.448 2 11 2.448 11 3V11H3C2.448 11 2 11.448 2 12C2 12.552 2.448 13 3 13H11V21C11 21.552 11.448 22 12 22C12.552 22 13 21.552 13 21V13H21C21.552 13 22 12.552 22 12C22 11.448 21.552 11 21 11H13Z"/>

</svg>
);


export const MinusIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15.21" height="15.21" viewBox="0 0 24 24">
    <path fill="#FF0000" d="M19 13H5C4.448 13 4 13.448 4 14C4 14.552 4.448 15 5 15H19C19.552 15 20 14.552 20 14C20 13.448 19.552 13 19 13Z"/>
  </svg>
);

export const PrintIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15.21"
    height="15.21"
    viewBox="0 0 24 24"
    fill="#3E88EF"
  >
    <path d="M6 9V2h12v7h4v10h-4v3H6v-3H2V9h4zm2 11h8v-5H8v5zm0-7h8V4H8v9z" />
   {/*  <path d="M19 8H5c-1.1 0-2 .9-2 2v6h4v4h10v-4h4v-6c0-1.1-.9-2-2-2zm-3 10H8v-4h8v4zm1-10V4H7v4h10z" /> */}
  </svg>
)


export const SmallEditIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12.21" height="12.21" viewBox="0 0 15.21 15.21">
      <path fill="#3E88EF" d="M4.5,15.779v2.969H7.469l8.755-8.755L13.255,7.023ZM18.519,7.7a.788.788,0,0,0,0-1.116L16.667,4.728a.788.788,0,0,0-1.116,0L14.1,6.176l2.969,2.969Z"
        transform="matrix(0.998, -0.07, 0.07, 0.998, -4.803, -3.177)" />
    </svg>
  );
};

